import { render, staticRenderFns } from "./Dwv.vue?vue&type=template&id=df3807fc&scoped=true"
import script from "./Dwv.vue?vue&type=script&lang=js"
export * from "./Dwv.vue?vue&type=script&lang=js"
import style0 from "./Dwv.vue?vue&type=style&index=0&id=df3807fc&prod&lang=css&scoped=true"
import style1 from "./Dwv.vue?vue&type=style&index=1&id=df3807fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3807fc",
  null
  
)

export default component.exports